
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryCourseraTierProductConfigurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"acquisitionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CourseraTierSubscriptions_AcquisitionType"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentCadence"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CourseraTierSubscriptions_PaymentCadence"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CourseraTierSubscriptions_ProductType"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CourseraTierSubscriptionsQueries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryCourseraTierProductConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"acquisitionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"acquisitionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentCadence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentCadence"}}},{"kind":"Argument","name":{"kind":"Name","value":"tier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tier"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CourseraTierProductConfigurations"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CourseraTierProductConfigurations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_OwnableProductTuple"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownableProduct"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MonetaryAmount"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentConfiguration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legacyProductId"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentScheme"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentScheme"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OwnableProduct_SubscriptionPaymentScheme"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingCycle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfTrialDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refundDays"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MonetaryAmount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonetaryAmount"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":1006}};
    doc.loc.source = {"body":"query QueryCourseraTierProductConfigurations(\n  $acquisitionType: CourseraTierSubscriptions_AcquisitionType!\n  $paymentCadence: CourseraTierSubscriptions_PaymentCadence!\n  $tier: CourseraTierSubscriptions_ProductType!\n) {\n  CourseraTierSubscriptionsQueries {\n    queryCourseraTierProductConfigurations(\n      acquisitionType: $acquisitionType\n      paymentCadence: $paymentCadence\n      tier: $tier\n    ) {\n      ...CourseraTierProductConfigurations\n    }\n  }\n}\n\nfragment CourseraTierProductConfigurations on OwnableProduct_OwnableProductTuple {\n  ownableProduct {\n    id\n    productItemId\n    productType\n  }\n  price {\n    amount {\n      ...MonetaryAmount\n    }\n  }\n  fulfillmentConfiguration {\n    legacyProductId {\n      productItemId\n      productType\n    }\n    paymentScheme {\n      ...PaymentScheme\n    }\n  }\n}\n\nfragment PaymentScheme on OwnableProduct_SubscriptionPaymentScheme {\n  billingCycle\n  numberOfTrialDays\n  refundDays\n}\nfragment MonetaryAmount on MonetaryAmount {\n  value\n  currencyCode\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["QueryCourseraTierProductConfigurations"] = oneQuery(doc, "QueryCourseraTierProductConfigurations");
        
        module.exports["CourseraTierProductConfigurations"] = oneQuery(doc, "CourseraTierProductConfigurations");
        
        module.exports["PaymentScheme"] = oneQuery(doc, "PaymentScheme");
        
        module.exports["MonetaryAmount"] = oneQuery(doc, "MonetaryAmount");
        
